import { render, staticRenderFns } from "./Gas.vue?vue&type=template&id=59a4ded0&scoped=true&"
import script from "./Gas.vue?vue&type=script&lang=js&"
export * from "./Gas.vue?vue&type=script&lang=js&"
import style0 from "./Gas.vue?vue&type=style&index=0&id=59a4ded0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59a4ded0",
  null
  
)

export default component.exports